export default __webpack_public_path__ + "static/media/zuiderpark1.00866446.jpg";